<template>
    <b-list-group-item
        href="javascript:void(0)"
        class="flex-column align-items-start"
        @click="onClick()"
        ref="container"
    >
        <div class="d-flex w-100 justify-content-between">
            <h5 class="mb-1">{{ header }}</h5>
            <span @click.stop.prevent="onDismiss()">
                <font-awesome-icon :icon="['fas', 'xmark']" size="lg" class="text-danger"></font-awesome-icon>
            </span>
        </div>
        <div class="mb-1" :class="{ 'text-nowrap': !message.expanded }" v-html="body"></div>
        <div class="mt-3 mb-1" v-if="message.expanded">
            <button @click.stop.prevent="onDismiss()">Dismiss</button>
        </div>
    </b-list-group-item>
</template>

<script>
import Vue from 'vue';
import DOMPurify from 'dompurify';
import utils from '../../../../utils';
import scrolltoUtils from 'vue-scrollto/src/utils';

export default {
    name: 'HeaderMessage',
    props: {
        message: Object,
        onDismissAction: String,
    },
    computed: {
        el() {
            return this.$refs.container;
        },
        header() {
            return DOMPurify.sanitize(this.message.header, { ALLOWED_TAGS: [] });
        },
        truncated() {
            const body = DOMPurify.sanitize(this.message.body, { ALLOWED_TAGS: [] });
            if (body.length > 28) {
                return body.substring(0, 28) + '...';
            }
            return body;
        },
        full() {
            const body = this.message.body.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2');
            return DOMPurify.sanitize(body, {
                ALLOWED_TAGS: ['a', 'b', 'strong', 'i', 'p', 'br'],
                ALLOWED_ATTR: ['href', 'target'],
            });
        },
        body() {
            return this.message.expanded ? this.full : this.truncated;
        },
    },
    methods: {
        onClick() {
            Vue.set(this.message, 'expanded', !this.message.expanded);
        },
        onDismiss() {
            // Prevent parent dropdown from closing after focus is lost
            this.$root.$once('bv::dropdown::hide', (event) => {
                event.preventDefault();
                // Return focus back to dropdown
                event.target.focus();
            });
            // Scroll to the message top if it's not visible
            const container = utils.scrollParent(this.el);
            const containerTop = utils.scrollTop(container);
            let cumulativeOffsetContainer = scrolltoUtils.cumulativeOffset(container);
            let cumulativeOffsetElement = scrolltoUtils.cumulativeOffset(this.el);
            const elementTop = cumulativeOffsetElement.top - cumulativeOffsetContainer.top;
            if (elementTop < containerTop) {
                this.$scrollTo(this.el, 500, { container: container });
            }
            // Hide this message
            this.$store.dispatch(String(this.onDismissAction), this.message);
        },
    },
};
</script>
